import React from 'react'
import Plot from 'react-plotly.js'
import { Card, CardContent, Typography } from '@mui/material'
import './ClassificationChart.scss'

export default function ClassificationChart({ data }) {
    if (!data) {
        return (
            <Card className="classification-chart-card">
                <CardContent>
                    <Typography variant="h6">Klassifikationsverteilung der Falldaten</Typography>
                    <Typography variant="body2" color="textSecondary">
                        Keine Klassifikationsdaten verfügbar
                    </Typography>
                </CardContent>
            </Card>
        )
    }

    // Filter out categories with 0 values
    const categories = []
    const values = []
    const labels = []
    const colors = []
    
    if (data.pathogenic > 0) {
        categories.push('pathogenic')
        values.push(data.pathogenic)
        labels.push('Pathogen')
        colors.push('#d32f2f') // Dark red
    }
    
    if (data.likelyPathogenic > 0) {
        categories.push('likelyPathogenic')
        values.push(data.likelyPathogenic)
        labels.push('Wahrscheinlich Pathogen')
        colors.push('#f57c00') // Orange
    }
    
    if (data.uncertain > 0) {
        categories.push('uncertain')
        values.push(data.uncertain)
        labels.push('Unsichere Bedeutung')
        colors.push('#fbc02d') // Yellow
    }
    
    if (data.likelyBenign > 0) {
        categories.push('likelyBenign')
        values.push(data.likelyBenign)
        labels.push('Wahrscheinlich Benign')
        colors.push('#689f38') // Light green
    }
    
    if (data.benign > 0) {
        categories.push('benign')
        values.push(data.benign)
        labels.push('Benign')
        colors.push('#388e3c') // Dark green
    }
    
    if (values.length === 0) {
        return (
            <Card className="classification-chart-card">
                <CardContent>
                    <Typography variant="h6">Klassifikationsverteilung der Falldaten</Typography>
                    <Typography variant="body2" color="textSecondary">
                        Keine Klassifikationsdaten verfügbar
                    </Typography>
                </CardContent>
            </Card>
        )
    }

    const total = values.reduce((sum, val) => sum + val, 0)
    
    const plotData = [{
        values: values,
        labels: labels,
        type: 'pie',
        hole: 0.4,
        marker: {
            colors: colors
        },
        textinfo: 'label+percent',
        textposition: 'outside',
        hovertemplate: '%{label}<br>%{value} Varianten<br>%{percent}<extra></extra>',
        sort: false
    }]

    const layout = {
        title: 'Variantenklassifikation (Klassifizierte Varianten)',
        height: 400,
        showlegend: true,
        legend: {
            orientation: 'v',
            y: 0.5,
            x: 1.1
        },
        margin: {
            l: 50,
            r: 150,
            t: 50,
            b: 50
        },
        paper_bgcolor: 'white',
        annotations: [
            {
                text: `<b>${total.toLocaleString('de-DE')}</b><br>Klassifiziert`,
                showarrow: false,
                x: 0.5,
                y: 0.5,
                font: {
                    size: 20
                }
            }
        ]
    }

    const config = {
        responsive: true,
        displayModeBar: false
    }

    return (
        <Card className="classification-chart-card">
            <CardContent>
                <Plot
                    data={plotData}
                    layout={layout}
                    config={config}
                    className="classification-plot"
                />
            </CardContent>
        </Card>
    )
}